import {call, put} from "typed-redux-saga";
import {fetchGamesJSONSuccess, fetchGamesJSONFailed} from "apps/BUDWEISERPOTM/modules/actions";
import {ContentPredictorApi} from "apps/BUDWEISERPOTM/modules/utils";

export const fetchGamesSaga = function* () {
	try {
		const result = yield* call(ContentPredictorApi.JSON.games);
		yield* put(
			fetchGamesJSONSuccess(result)
		);
	} catch (err) {
		const {message} = err as Error;
		yield* put(fetchGamesJSONFailed(message));
	}
};
